import gql from 'graphql-tag'

export default gql`
  mutation (
    $_id: MongoID!
    $firstname: String
    $lastname: String
    $avatar: String
    $mobile: String
    $email: String
    $description: String
      ){
    updateTeacherUser(_id:$_id,
      record:{
        email: $email,
        mobile: $mobile,
        avatar: $avatar,
        lastname: $lastname,
        firstname: $firstname,
        description: $description,
      })
      {
        recordId
      }
  }
`